import {create} from 'zustand';
import {EmbeddedInfoStore} from './types';

const useEmbeddedInfoStore = create<EmbeddedInfoStore>(set => ({
	openEmbeddedInfo: false,
	setOpenEmbeddedInfo: value => set({openEmbeddedInfo: value}),
}));

export {useEmbeddedInfoStore};
